import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import AdvancedIcon from "@icons/myicons/tools.svg?react";
import { SettingsMenuItem } from "@features/settings/components/SettingsSidebar/SettingsMenuItem";

export const SettingsMenu = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;

  return (
    <Box>
      <Typography
        variant="overline"
        color="textSecondary"
        textTransform="uppercase"
        mb={1.5}
        ml={2}
      >
        {t("settings.sidebar.common.title")}
      </Typography>
      <Box display="flex" flexDirection="column" gap={0.5}>
        <SettingsMenuItem
          to="/settings/advanced"
          title={t("settings.sidebar.common.advanced")}
          icon={<AdvancedIcon fontSize="small" />}
          active={pathname === "/settings/advanced"}
        />
      </Box>
    </Box>
  );
};
